import * as Yup from "yup";

import {
  CarOwner,
  CarProductDetailsFormValues,
} from "./FormElements/interfaces";

import { getInjuriesSchema } from "Components/Form/RecentDamages/validation";
import { useTexts } from "Components/TextContext";
import { BonusTransfer } from "Store/interfaces/CompanyTransferSpecifications";
import { BooleanFormType } from "Store/interfaces/FormTypes";

export const validationSchema =
  (getText: ReturnType<typeof useTexts>["getText"]) =>
  (): Yup.ObjectSchema<CarProductDetailsFormValues> => {
    return Yup.object({
      automaticallyPopulated: Yup.boolean().defined(),
      bonusPreOwnership: Yup.mixed<BonusTransfer>().required(),
      bonus: Yup.string().required(getText("carform.validation.bonus")),
      mortgagee: Yup.mixed<BooleanFormType>().when("carOwner", {
        is: (carOwner: CarOwner) => carOwner !== CarOwner.LEASING,
        then: (schema) =>
          schema.required(getText("carform.validation.morgagee")),
      }),
    })
      .concat(getInjuriesSchema())
      .defined();
  };
